import { apiClient } from '../client';

/** W4 (B2-billing): the organisation's Stripe invoices (admins). 503 STRIPE_NOT_CONFIGURED without Stripe. */
export interface Invoice {
  id: string;
  number: string | null;
  status: string;
  amount_due: number;
  amount_paid: number;
  currency: string;
  created: string;
  period_start: string | null;
  period_end: string | null;
  hosted_invoice_url: string | null;
  invoice_pdf: string | null;
}

export function listInvoices(signal?: AbortSignal) {
  return apiClient.get<{ invoices: Invoice[]; has_customer: boolean }>('/billing/invoices', { signal });
}
